<template>
  <footer>
    <div class="footer_box">
      <ul class="info">
        <li>
          <router-link :to="{ name: 'aboutUs' }">关于我们</router-link>
          <router-link :to="{ name: 'contactUs' }">联系我们</router-link>
          <a href="">加入我们</a>
          <router-link :to="{ name: 'faq' }">常见问题</router-link>
        </li>
        <li>
          <nav>
            <a href="">意见反馈</a>
            <a href="">平台功能介绍</a>
          </nav>
        </li>
      </ul>
      <figure>
        <div class="contact">
          <div class="tel">
            <i class="icon-telephone"></i>
            <p><span>咨询热线</span><b><a href="tel:0755-22658484">0755-22658484</a></b></p>
          </div>
          <!-- <button>在线咨询</button> -->
          <p class="time"><i class="icon-shijian"></i><span>周一至周日 09:00-19:00</span></p>
        </div>
        <ul class="qrcode">
          <li><img src="@assets/img/cserweima.jpg" alt="" /><span>微信公众号</span></li>
          <li><img src="@assets/img/qrcode.png" alt="" /><span>官网二维码</span></li>
        </ul>
      </figure>
      <div class="bottom">
        <ul>

          <li>旅行社业务经营许可证编号L-GD-CJ00454 Copyright © 2025 常顺旅行 <a target="_blank"
              href="https://beian.miit.gov.cn">粤ICP备14092297号-2</a></li>
          <li>邮寄地址：深圳市罗湖区深南东路1027号文华大厦西座25层DE</li>
        </ul>
        <div class="pic">
          <figure class="complainWrap">24小时投诉电话: <a href="tel:0755-22931183"> <i
                class="icon-telephone"></i>0755-22931183</a></figure>
          <figure class="complainWrap"><a href="https://www.wjx.cn/vm/O95QRkV.aspx" target="_blank">
              <i class="icon-xing"></i> <i class="icon-xing"></i> <i class="icon-xing"></i> <span>服务质量满意度调查</span>
              <i class="icon-xing"></i> <i class="icon-xing"></i> <i class="icon-xing"></i>
            </a>
          </figure>
          <!-- <a href=""><img src="@assets/img/110×40.png" alt=""></a>
          <a href=""><img src="@assets/img/134×50.png" alt=""></a>
          <a href=""><img src="@assets/img/govIcon.gif" alt=""></a> -->
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {}
  }
}
</script>

<style scoped src="./index.css"></style>